<script>
	import { onMount } from 'svelte';

	const outsideImage = 'images/ut.png';
	const insideImage  = 'images/in.png';

	let isDesktop = false;
	onMount(() => {
		isDesktop = window.matchMedia('(min-width: 640px)').matches;
	});

	const generalStats = [
		{ label: 'Totalvikt',      value: '1 000 kg' },
		{ label: 'Vikt utan last', value: '610 kg' },
		{ label: 'Lastkapacitet',  value: '390 kg' }
	];

	const exteriorMeasurements = [
		{ label: 'Total höjd', color: 'green', value: '260 cm' },
		{ label: 'Total bredd', color: 'blue',  value: '222 cm' }
	];

	const interiorMeasurements = [
		{ label: 'Djup',              color: 'orange', value: '368 cm' },
		{ label: 'Bredd',             color: 'yellow', value: '154 cm' },
		{ label: 'Höjd öppning',      color: 'green',  value: '190 cm' },
		{ label: 'Höjd högsta punkt', color: 'red',    value: '210 cm' },
		{ label: 'Volym',             color: null,     value: '10,76 m³' }
	];
</script>

<div class="page">
	<header class="page-header">
		<div class="title-group">
			<h1>Släpet</h1>
			<p class="subtitle">Teknisk specifikation</p>
		</div>
		<div class="reg-badge" aria-label="Registreringsnummer XHF 796">
			<span class="reg-badge__strip">S</span>
			<span class="reg-badge__number">XHF 796</span>
		</div>
	</header>

	<main class="content">
		<section class="card general-card" aria-label="Allmän information">
			<h2 class="card-title">Allmän information</h2>
			<div class="stats-grid">
				{#each generalStats as stat, i}
					<div class="stat" class:stat--divided={i < generalStats.length - 1}>
						<div class="stat__value">{stat.value}</div>
						<div class="stat__label">{stat.label}</div>
					</div>
				{/each}
			</div>
		</section>

		<div class="measurements-grid">
			<section class="card" aria-label="Utvändiga mått">
				<h2 class="card-title">Utvändiga mått</h2>
				{#each exteriorMeasurements as row}
					<div class="spec-row">
						{#if row.color}
							<span class="swatch swatch--{row.color}" aria-hidden="true"></span>
						{:else}
							<span class="swatch swatch--empty" aria-hidden="true"></span>
						{/if}
						<span class="spec-label">{row.label}</span>
						<span class="spec-value">{row.value}</span>
					</div>
				{/each}
				<details open={isDesktop} class="image-toggle">
					<summary>Visa referensbild</summary>
					<img src={outsideImage} alt="Utvändiga mått med inritade mätlinjer" class="ref-image" />
				</details>
			</section>

			<section class="card" aria-label="Invändiga mått">
				<h2 class="card-title">Invändiga mått</h2>
				{#each interiorMeasurements as row}
					<div class="spec-row">
						{#if row.color}
							<span class="swatch swatch--{row.color}" aria-hidden="true"></span>
						{:else}
							<span class="swatch swatch--empty" aria-hidden="true"></span>
						{/if}
						<span class="spec-label">{row.label}</span>
						<span class="spec-value">{row.value}</span>
					</div>
				{/each}
				<details open={isDesktop} class="image-toggle">
					<summary>Visa referensbild</summary>
					<img src={insideImage} alt="Invändiga mått med inritade mätlinjer" class="ref-image" />
				</details>
			</section>
		</div>
	</main>

	<footer class="page-footer">
		<p>Registreringsnummer XHF 796</p>
	</footer>
</div>

<style>
	.page {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* ── Header ── */
	.page-header {
		background: var(--surface);
		border-bottom: 1px solid var(--border);
		padding: 1.5rem 1.5rem 1.25rem;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 1rem;
	}

	.title-group {
		display: flex;
		flex-direction: column;
		gap: 0;
	}

	h1 {
		margin: 0;
		font-size: clamp(2rem, 6vw, 3.5rem);
		font-weight: 700;
		letter-spacing: -0.02em;
		color: var(--text-primary);
		line-height: 1.1;
	}

	.subtitle {
		margin: 0.25rem 0 0;
		font-size: 0.875rem;
		color: var(--text-secondary);
	}

	/* ── Reg badge ── */
	.reg-badge {
		display: inline-flex;
		align-items: stretch;
		border: 2px solid var(--accent);
		border-radius: 6px;
		overflow: hidden;
		font-weight: 700;
		font-size: 1.125rem;
		letter-spacing: 0.05em;
		white-space: nowrap;
	}

	.reg-badge__strip {
		background: var(--accent);
		color: #fff;
		padding: 0.2em 0.45em;
		font-size: 0.65em;
		display: flex;
		align-items: center;
		font-weight: 800;
	}

	.reg-badge__number {
		padding: 0.2em 0.6em;
		color: var(--text-primary);
	}

	/* ── Content layout ── */
	.content {
		flex: 1;
		max-width: 800px;
		width: 100%;
		margin: 0 auto;
		padding: 1.5rem 1rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	/* ── Cards ── */
	.card {
		background: var(--surface);
		border: 1px solid var(--border);
		border-radius: 12px;
		padding: 1.25rem 1.5rem;
		box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
	}

	.card-title {
		margin: 0 0 1rem;
		font-size: 0.6875rem;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.1em;
		color: var(--text-secondary);
		padding-bottom: 0.75rem;
		border-bottom: 1px solid var(--border);
	}

	/* ── General info stats ── */
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}

	.stat {
		text-align: center;
		padding: 0.75rem 0.5rem;
	}

	.stat--divided {
		border-right: 1px solid var(--border);
	}

	.stat__value {
		font-size: 1.375rem;
		font-weight: 700;
		color: var(--text-primary);
		line-height: 1.2;
	}

	.stat__label {
		font-size: 0.75rem;
		color: var(--text-secondary);
		margin-top: 0.25rem;
	}

	/* ── Measurements grid ── */
	.measurements-grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 1rem;
	}

	@media (min-width: 640px) {
		.measurements-grid {
			grid-template-columns: 1fr 1fr;
		}
	}

	/* ── Spec rows ── */
	.spec-row {
		display: grid;
		grid-template-columns: 16px 1fr auto;
		align-items: center;
		gap: 0.75rem;
		padding: 0.5rem 0.4rem;
		border-radius: 6px;
		transition: background 0.12s;
	}

	.spec-row:hover {
		background: var(--surface-alt);
	}

	.swatch {
		width: 12px;
		height: 12px;
		border-radius: 50%;
		flex-shrink: 0;
	}

	.swatch--green  { background: var(--color-green); }
	.swatch--blue   { background: var(--color-blue); }
	.swatch--orange { background: var(--color-orange); }
	.swatch--yellow { background: var(--color-yellow); border: 1px solid #ca8a04; }
	.swatch--red    { background: var(--color-red); }
	.swatch--empty  { background: transparent; }

	.spec-label {
		font-size: 0.875rem;
		color: var(--text-secondary);
	}

	.spec-value {
		font-size: 0.9375rem;
		font-weight: 600;
		color: var(--text-primary);
		white-space: nowrap;
	}

	/* ── Image toggle ── */
	.image-toggle {
		margin-top: 1rem;
		border-top: 1px solid var(--border);
		padding-top: 0.75rem;
	}

	.image-toggle summary {
		cursor: pointer;
		font-size: 0.8125rem;
		color: var(--accent);
		user-select: none;
		list-style: none;
	}

	.image-toggle summary::-webkit-details-marker {
		display: none;
	}

	.image-toggle summary::before {
		content: '▶ ';
		font-size: 0.625rem;
	}

	.image-toggle[open] summary::before {
		content: '▼ ';
	}

	.ref-image {
		display: block;
		max-width: 100%;
		margin-top: 0.75rem;
		border-radius: 8px;
		border: 1px solid var(--border);
	}

	/* ── Footer ── */
	.page-footer {
		text-align: center;
		padding: 1rem;
		font-size: 0.75rem;
		color: var(--text-secondary);
		border-top: 1px solid var(--border);
		background: var(--surface);
	}

	.page-footer p {
		margin: 0;
	}
</style>
